import { store } from '@/store';
import ToastService from '@/modules/toasts/services/ToastService';
import WCSimpleToast from '@/modules/toasts/components/WCSimpleToast/WCSimpleToast.vue';

/**
 * Reject employee access for all pages expect employee pages
 * @param {*} to destination
 * @param {*} from source
 * @param {*} next next route
 */
export default async function rejectEmployeeAccess(to, from, next) {
  const isEmployee = store.getters['user/isEmployee'];
  const isCustomer = store.getters['user/isCustomer'];

  /* Check if logged in user is only employee (not associated with any customer),
   * then restrict access, else redirect
   */
  if (isEmployee && !isCustomer) {
    next({ name: 'EmployeeCustomerSelect' });
    ToastService.open(WCSimpleToast, {
      props: {
        variant: 'warning',
        title: 'Authentication',
        message: 'Associate as customer to access the page',
      },
      timeout: 7000,
    });
  } else {
    next();
  }
}
